export default {
  "localhost": {
    web: 'nethosweb.diandianys.com',
    // api: "//nethos.diandianys.com/api/app",
    api: 'https://api-test.gjwlyy.com/api/app',
    // api: 'https://app3.z2ehospital.com/api/app',
    reptile: '//api.limingwei.name',
    jssdk: "wx.hztywl.cn",
    socket: "//nethoswebsocket.diandianys.com",
    nali: 'http://ssltest.ngarihealth.com/weixin-prerelease/zehys/auth.html',
    // chufang: 'http://hzwap.zdxym.com',
    // chufang: 'https://testpwap.51linked.cn',
    chufang: 'https://drug-test.zjwlyy.cn/patienth5/index.html',
    bl: 'http://wxtest.zhicall.cn/wechat-webIII/hospitalIndex/10372/index#/index',
    yx: 'https://zjyx.gjwlyy.com/cloudfilm/tpreport',// 影像地址
    alipay_oauth2: 'http://nethosweb.diandianys.com',
    wx_oauth2: 'http://wechat-repeater.hztywl.cn',
    oauthurl: "https://nethos.diandianys.com",
    appid: "wx6e3551dee5f7e716",
    plat: "dev",
    team: '5ade811584ae5b958bba6451',
    lanniuh: 'https://www.lanniuh.com/hug-web/c/user/47000323-0/1003',
    wuhan: 'https://wuhan.lanniuh.com/pneumonia/patient/third-party',
    wuhanCode: '47000323-0',
    weixinPay: 'wx6e3551dee5f7e716',
    channel: 3
  },
  "nethosweb.diandianys.com": {
    web: 'nethosweb.diandianys.com',
    api: "//nethos.diandianys.com/api/app",
    // api: '//api-test.gjwlyy.com/api/app',
    // api: '//api.gjwlyy.com/api/app',
    reptile: '//api.limingwei.name',
    jssdk: "wx.hztywl.cn",
    socket: "//nethoswebsocket.diandianys.com",
    nali: 'http://ssltest.ngarihealth.com/weixin-prerelease/zehys/auth.html',
    //chufang: 'http://hzwap.zdxym.com',
    chufang: 'https://drug-test.zjwlyy.cn/patienth5/index.html',
    bl: 'http://wxtest.zhicall.cn/wechat-webIII/hospitalIndex/10372/index#/index',
    yx: 'https://zjyx.gjwlyy.com/cloudfilm/tpreport',// 影像地址
    alipay_oauth2: 'http://nethosweb.diandianys.com',
    wx_oauth2: 'http://wechat-repeater.hztywl.cn',
    oauthurl: "https://nethos.diandianys.com",
    appid: "wx6e3551dee5f7e716",
    plat: "dev",
    team: '5ade811584ae5b958bba6451',
    lanniuh: 'https://www.lanniuh.com/hug-web/c/user/47000323-0/1003',
    wuhan: 'https://wuhan.lanniuh.com/pneumonia/patient/third-party',
    wuhanCode: '47000323-0',
    weixinPay: 'wx6e3551dee5f7e716',
    channel: 3
  },
  "wx.hztywl.cn": {
    web: 'nethosweb.diandianys.com',
    api: "//nethos.diandianys.com/api/app",
    zuoshou_api: '',
    reptile: '//api.limingwei.name',
    jssdk: "wx.hztywl.cn",
    socekt: "//nethoswebsocket.diandianys.com",
    nali: 'http://ssltest.ngarihealth.com/weixin-prerelease/zehys/auth.html',
    //chufang: 'http://hzwap.zdxym.com',
    chufang: 'https://drug-test.zjwlyy.cn/patienth5/index.html',
    bl: 'http://wxtest.zhicall.cn/wechat-webIII/hospitalIndex/10372/index#/index',
    yx: 'https://zjyx.gjwlyy.com/cloudfilm/tpreport',
    alipay_oauth2: 'http://nethos-webtest.diandianys.com',
    wx_oauth2: 'http://wechat-repeater.hztywl.cn',
    oauthurl: "https://nethos.diandianys.com",
    appid: "wx6e3551dee5f7e716",//wxc0b2666f5aa596d8//wxa49f90b4ff678ef2//wx6d20bfd9237d1725
    plat: "dev",
    team: '5ade811584ae5b958bba6451',
    lanniuh: 'https://www.lanniuh.com/hug-web/c/user/47000323-0/1003',
    wuhan: 'https://wuhan.lanniuh.com/pneumonia/patient/third-party',
    wuhanCode: '47000323-0',
    weixinPay: 'wx6e3551dee5f7e716',// wx6e3551dee5f7e716// wxa49f90b4ff678ef2
    channel: 3
  },
  "test-zheer-wx.hztywl.cn": {
    web: 'nethosweb.diandianys.com',
    api: "//nethos.diandianys.com/api/app",
    zuoshou_api: '',
    reptile: '//api.limingwei.name',
    jssdk: "wx.hztywl.cn",
    socekt: "//nethoswebsocket.diandianys.com",
    nali: 'http://ssltest.ngarihealth.com/weixin-prerelease/zehys/auth.html',
    chufang: 'https://drug-test.zjwlyy.cn/patienth5/index.html',
    bl: 'http://wxtest.zhicall.cn/wechat-webIII/hospitalIndex/10372/index#/index',
    yx: 'https://zjyx.gjwlyy.com/cloudfilm/tpreport',
    alipay_oauth2: 'http://nethos-webtest.diandianys.com',
    wx_oauth2: 'http://wechat-repeater.hztywl.cn',
    oauthurl: "https://nethos.diandianys.com",
    appid: "wxa49f90b4ff678ef2",//wxc0b2666f5aa596d8//wxa49f90b4ff678ef2//wx6d20bfd9237d1725
    plat: "dev",
    team: '5ade811584ae5b958bba6451',
    lanniuh: 'https://www.lanniuh.com/hug-web/c/user/47000323-0/1003',
    wuhan: 'https://wuhan.lanniuh.com/pneumonia/patient/third-party',
    wuhanCode: '47000323-0',
    weixinPay: 'wxa49f90b4ff678ef2',
    channel: 3
  },
  "pat-test.gjwlyy.com": {
    web: 'pat-test.gjwlyy.com',
    api: "//api-test.gjwlyy.com/api/app",
    reptile: '//api.limingwei.name',
    jssdk: "test-zheer-wx.hztywl.cn",
    socket: "doc-test.gjwlyy.com",
    nali: 'http://ssltest.ngarihealth.com/weixin-prerelease/zehys/auth.html',
    chufang: 'https://drug-test.zjwlyy.cn/patienth5/index.html',
    bl: 'http://wxtest.zhicall.cn/wechat-webIII/hospitalIndex/10372/index#/index',
    yx: 'https://zjyx.gjwlyy.com/cloudfilm/tpreport',
    alipay_oauth2: 'http://nethos-webtest.diandianys.com',
    wx_oauth2: 'http://wechat-repeater.hztywl.cn',
    oauthurl: "https://api-test.gjwlyy.com",
    appid: "wxa6edd506cfc21469",
    plat: "pro",
    team: '5ade811584ae5b958bba6451',
    lanniuh: 'https://www.lanniuh.com/hug-web/c/user/47000323-0/1003',
    wuhan: 'https://wuhan.lanniuh.com/pneumonia/patient/third-party',
    wuhanCode: '47000323-0',
    weixinPay: 'wx6e3551dee5f7e716',
    channel: 11
  },
  "app2.z2web1.com": {
    web: 'app2.z2web1.com',
    api: "//app3.z2web1.com/api/app",
    reptile: '//api.limingwei.name',
    jssdk: "app2.z2web1.com",
    socket: "app7.z2web1.com",
    nali: 'https://weixin.ngarihealth.com/weixin/zehys/auth.html',
    chufang: 'https://smart05.gjwlyy.com/prescription/patienth5/index.html',
    bl: 'https://bakd.zhicall.cn/#/index',
    yx: 'https://zjyx.gjwlyy.com/cloudfilm/tpreport',
    alipay_oauth2: 'https://app2.z2web1.com',
    wx_oauth2: 'https://app5.z2web1.com',
    oauthurl: "https://app3.z2web1.com",
    appid: "wx3d274480f31f6de2",
    plat: "pro",
    team: '5ade811584ae5b958bba6451',
    lanniuh: 'https://www.lanniuh.com/hug-web/c/user/47000323-0/1003',
    wuhan: 'https://wuhan.lanniuh.com/pneumonia/patient/third-party',
    wuhanCode: '47000323-0',
    weixinPay: 'wx3d274480f31f6de2',
    channel: 10
  },
  "app2.z2ehospital.com": {
    web: 'app2.z2ehospital.com',
    api: "//app3.z2ehospital.com/api/app",
    reptile: '//api.limingwei.name',
    jssdk: "app2.z2ehospital.com",
    socket: "app7.z2ehospital.com",
    nali: 'https://weixin.ngarihealth.com/weixin/zehys/auth.html',
    chufang: 'https://smart05.gjwlyy.com/prescription/patienth5/index.html',
    bl: 'https://bakd.zhicall.cn/#/index',
    yx: 'https://zjyx.gjwlyy.com/cloudfilm/tpreport',
    alipay_oauth2: 'https://app2.z2ehospital.com',
    wx_oauth2: 'https://app5.z2ehospital.com',
    oauthurl: "https://app3.z2ehospital.com",
    appid: "wx3d274480f31f6de2",
    plat: "pro",
    team: '5ade811584ae5b958bba6451',
    lanniuh: 'https://www.lanniuh.com/hug-web/c/user/47000323-0/1003',
    wuhan: 'https://wuhan.lanniuh.com/pneumonia/patient/third-party',
    wuhanCode: '47000323-0',
    weixinPay: 'wx3d274480f31f6de2',
    channel: 10
  },
  "www.gjwlyy.com": {
    web: 'www.gjwlyy.com',
    api: "//api.gjwlyy.com/api/app",
    reptile: '//api.limingwei.name',
    jssdk: "www.gjwlyy.com",
    socket: "socket.gjwlyy.com",
    nali: 'https://weixin.ngarihealth.com/weixin/zehys/auth.html',
    chufang: 'https://smart05.gjwlyy.com/prescription/patienth5/index.html',
    bl: 'https://bakd.zhicall.cn/#/index',
    yx: 'https://zjyx.gjwlyy.com/cloudfilm/tpreport',
    alipay_oauth2: 'https://www.gjwlyy.com',
    wx_oauth2: 'http://wechat-repeater.gjwlyy.com',
    oauthurl: "https://api.gjwlyy.com",
    appid: "wx3d274480f31f6de2",
    plat: "pro",
    team: '5ade811584ae5b958bba6451',
    lanniuh: 'https://www.lanniuh.com/hug-web/c/user/47000323-0/1003',
    wuhan: 'https://wuhan.lanniuh.com/pneumonia/patient/third-party',
    wuhanCode: '47000323-0',
    weixinPay: 'wx3d274480f31f6de2',
    channel: 10
  }
}

// https://zjyx.gjwlyy.com/cloudfilm/tpreport?hospitalId=95710002&accessNumber=26052378&patientId=&p=EZSzM4P%2F69f%2FCmgNB1Cw%2Bz6IoY72TNxhP3%2FCbttiHediR4aPXRq02hwrCrXXJktH1coEdS5oPYbLoodoFYb9VKJbWTgh8C3E%2B2K4%2BlRuIoM%3D#tp-report-detail
// https://www.gjwlyy.com/gjhlwyy/#//report/detail/image?accessionNumber=26052378&newUrl=1



// WEBPACK FOOTER //
// ./src/lib/api.config.js